<template>
  <div v-if="isShowList">
    <div class="flex text-xs">
      <div class="flex-grow">
        {{ $i18nPresenter.t('Presenters') }}
        <aha-icon
          name="question-o"
          height="12"
          width="12"
          viewBox="0 0 12 12"
          maintainColor="false"
          v-tooltip="$i18nPresenter.t(
            'Can present independently. Only sees their own session reports. Content cannot be edited.'
          )"
        />
      </div>
      <div v-if="collaborators.length > 1">
        {{ collaborators.length }} {{ $i18nPresenter.t('people') }}
      </div>
    </div>
    <div v-if="!isLoading && !collaborators.length" class="mt-3 text-sm">
      {{ $i18nPresenter.t('Invite teammates to edit or assign presenters to run sessions.') }}
    </div>
    <div
      v-for="(collaborator) in collaborators"
      :key="`instructor-` + collaborator.email"
      class="collaborator-item individual-collaborator-item"
    >
      <div class="flex flex-row items-center">
        <aha-avatar
          class="mr-2"
          :name="getCollaboratorName(collaborator)"
          :image="collaborator.avatar"
          :width="36"
          :height="36"
          :id="collaborator.id"
        />
        <div class="collaborator-info">
          <div class="collaborator-info__name mb-1">
            <span class="relative">
              {{ getCollaboratorName(collaborator) }}
            </span>
          </div>
          <p class="collaborator-info__email">
            {{ collaborator.email }}
          </p>
        </div>
        <div class="collaborator-role" :id="`collaborator-instructor-${collaborator.email}`">
          <span v-if="collaborator.role === 'owner'">
            {{ $i18nPresenter.t('Owner') }}
          </span>
          <!-- <span class="capitalize">
            Presenter
          </span> -->

          <span
            class="collaborator-role--dropdown-arrow"
            @click="toggleCollaboratorDropdown(collaborator.email)"
          >
            Presenter
            <aha-icon
              name="chevron-down-new"
              height="12"
              width="12"
              viewBox="0 0 12 12"
            />
          </span>
          <aha-context-menu
            :classList="'force-z-index'"
            :ref="`collaborator-menu-instructor-${collaborator.email}`"
            :target="`collaborator-instructor-${collaborator.email}`"
            :forceMenuPosition="true"
            :x="0"
            :y="getDropdownY(index)"
            @hide="onHideDropdown"
          >
            <aha-context-menu-item
              class="text-left"
              @click="removeCollaborator(collaborator)"
            >
              <aha-icon
                name="check"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                class="mr-1 text-primary-90"
                style="visibility: hidden"
              />
              <div class="grid w-48 py-2">
                <span class="leading-6 text-sm">{{ $i18nPresenter.t('Remove') }}</span>
              </div>
            </aha-context-menu-item>
          </aha-context-menu>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import EmailUtils from '@/utils/email'
import EventBus from '@/eventBus'

export default {
  components: {
  },
  props: {
    presentationId: {
      type: Number,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      collaborators: [],
      isLoading: true,
      isShowList: true,
    }
  },
  computed: {
  },
  mounted() {
    this.getListInstructor()
    EventBus.$on('change-list-instructor', () => {
      this.getListInstructor()
    })
  },
  destroyed() {
    EventBus.$off('change-list-instructor')
  },
  methods: {
    ...mapActions('multipleSessions', ['getListInstructorByPresentationIdAction', 'deleteInstructorAction']),
    async getListInstructor() {
      this.isLoading = true
      try {
        this.collaborators = await this.getListInstructorByPresentationIdAction(this.presentationId)
      } catch {
        this.isShowList = false
        // handle error
      }
      this.isLoading = false
    },
    getCollaboratorName(collaborator) {
      if (collaborator.id && collaborator.firstName) {
        return `${collaborator.firstName} ${collaborator.lastName}`
      }
      if (collaborator.email) {
        return EmailUtils.getEmailName(collaborator.email)
      }
      return 'Unknown user'
    },
    async removeCollaborator(collaborator) {
      await this.deleteInstructorAction({
        presentationId: this.presentationId,
        instructorIds: [collaborator.instructorId],
      })
      this.getListInstructor()
    },
    getDropdownY(index) {
      const listHeight = this.collaborators.length >= 4 ? 240 : this.collaborators.length * 60
      const dropdownHeight = 80
      const spaceBetweenItems = 70
      return (listHeight - index * spaceBetweenItems + this.scrollTop < dropdownHeight) ? -90 : 5
    },
    onHideDropdown() {
      const elem = document.querySelector('.aha-modal__content')
      if (elem) {
        elem.style.height = null
      }
    },

    toggleCollaboratorDropdown(email) {
      // Fix AHA-5280: The modal content height is automatically increasing on Firefox
      // So we need to fix a height here
      const elem = document.querySelector('.aha-modal__content')
      if (elem) {
        elem.style.height = `${elem.scrollHeight}px`
      }
      // Open the dropdown menu
      this.$refs[`collaborator-menu-instructor-${email}`][0].show()
    },
  },
}
</script>

<style lang="scss" scoped>
.collaborator-list-wrp {
  ::v-deep .context-menu-wrapper {
    min-width: 6rem;
    padding: 4px;
  }
  ::v-deep .context-menu-item {
    align-items: flex-start;
  }
  @media (max-width: 767px) {
    height: 100%;
  }
}

.collaborator-list {
  @apply pr-2 max-h-60 overflow-y-auto;
  &.share-v2{
    height: 370px;
    max-height: none;

    @media (max-width: 767px) {
      height: calc(100% - 110px)
    }
  }
}

.collaborator-item {
  @apply py-3;
}

.collaborator-info {
  width: 70%;
}

.collaborator-info__name {
  @apply font-bold;
}
.collaborator-info__email {
  @apply text-base-80 text-xs;
}

.collaborator-role {
  @apply ml-auto text-base-90 text-xs text-right relative;
  min-width: 60px;
}
.collaborator-role--dropdown {
  @apply bg-base-0 absolute top-5 right-0;
  @apply border border-base-30;
  @apply rounded w-24 z-30;
  box-shadow: 3px 3px 5px rgba(211, 215, 225, 0.42);
}
.collaborator-role--dropdown-item {
  @apply p-2;
  &.clickable {
    &:hover {
      @apply text-red-100;
    }
    @apply cursor-pointer;
  }
}
.collaborator-role--dropdown-arrow {
  @apply cursor-pointer z-20 capitalize;
}
.icon-empty {
  width: 16px;
}
.team-user {
  .collaborator-role {
    color: rgba(49, 49, 49, 0.5);
  }
  .collaborator-role--dropdown-arrow {
  @apply cursor-not-allowed z-20 capitalize;
}
}

</style>
